import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";

import back from "../../back.png";
import InputNIP from "../../helpers/InputNIP";
import InputPostCode from "../../helpers/InputPostCode";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputChecbox from "../../helpers/InputCheckbox";
import InputCombo from "../../helpers/InputCombo";
import InputEmail from "../../helpers/InputEmail";
import InputPhone from "../../helpers/InputPhone";
import InputInteger from "../../helpers/InputInteger";
import InputSearchClient from "../../helpers/InputSearchClient";
import InputDate from "../../helpers/InputDate";
import InputTextArea from "../../helpers/InputTextArea";
import InputDecimal from "../../helpers/InputDecimal";


function ServiceForm(props)
{

       const [errTab, setErrTab] = useState([]); 

       const [sl, setSl] = useState(null); 

       const [row, setRow] = useState({

                fak_umowy_id: props.umowa.id,

                id: -1,
                typ: 'n', ////'n | agr1 | agr2'


                data_rozpoczecia_uslugi: '',
                data_zakonczenia_uslugi: '',

                nazwa_uslugi: '',
                sl_uslugi_id: '-1',
                bill_cenniki_id: '-1',
                sl_kryteria_scalenia_id: '-1',
                ilosc: '1',
                aktywacja: '0',
                abonament: '0',
                stawka_vat: '23',
                platne_za_poprzedni: '0',
                informacje_dodatkowe: '',
                osobna_faktura: '0',
                accountcode: '',
                fakturowac: '1',
                numer_pstn: '',
                numer_info: '',
                usluga_aktywna: '1',
                rabat_na_polaczenia: '0',
                rabat_na_abonament: '0',
                rabat_na_abonament_il_okresow: '0',
                koszty_przekierowan: '0',
                koszty_przekierowan_gsm: '0',
                koszty_sms: '0',
                udzial70x: '0',

                //-------------------
                agr_link: 'https://',
                agr_akcja: '',
                agr_metoda: '',
                agr_parametr1: '',
                agr_parametr2: '',
                agr_parametr3: '',
                agr_parametr4: '',
                agr_cena_j_netto: '0',
               
            });
            var tmpRow = row;


      


    const valChangeListener = (filedName, val, correct, msg) => {   
        
   
        
                console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 

                var tabCheck = filedName.split('@');
                if(tabCheck.length == 2)
                {
                    var tabName = tabCheck[0];
                    var tabInx  = tabCheck[1];
                    var tRef = row[tabName];
                    if(correct)tRef[tabInx] = val;
                    if(!correct)tRef[tabInx] = "";

                    tmpRow[tabName] = tRef;     
                    setRow(  JSON.parse(JSON.stringify(tmpRow)) );  
        
                    //setRowX( {...row, [tabName]:tRef } );   
                    if(Config.env == "dev") console.log("ClientForm valChangeListner", tmpRow);
                    return;
                }

               
         
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;         

                if(filedName == 'typ' && ( val=='agr1' || val=='agr2'  ) )
                {
                      
                    tmpRow["sl_uslugi_id"] = 13;
                    tmpRow["sl_uslugi_id_valid"] = true;        
                }

                if(filedName == 'typ' &&  val == 'n'  )
                {             
                    tmpRow["sl_uslugi_id"] = 7;    //usluga 703
                    tmpRow["sl_uslugi_id_valid"] = true;                                         

                    tmpRow["bill_cenniki_id"] = 1;    //cennik domyslny
                    tmpRow["bill_cenniki_id_valid"] = true;   
                }
 
                setRow(  JSON.parse(JSON.stringify(tmpRow)) );    
            
                //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );                          
 
            }   
        
        
        const goNextNew = () => {
                console.log("goNext");               
            }



        const valChecker = (fields) => {

                var allValid = true;

                    
                console.log(JSON.stringify(fields) );

                Object.entries(fields).forEach(function(entry) {

                    var xKey    = entry[0];
                    var xValue  = entry[1];                    

                    var xValidName = xKey + "_valid";

                    if(fields[xValidName] == false)
                    {
                        allValid = false;
                        if(Config.env == 'dev') console.log("Error field: " + xKey);
                    }
                    
                });
                
                return allValid;

            }

            
        const saveData = () => {
                

                if(!valChecker(row))
                {
                        props.mainView.showDialog("Ups!" , "Wypełnij prawidłowo pola formularza"  ,  "error"  ,null); 
                        return;
                }


                if(row.typ == 'n') //normal..
                {
                    if(row.abonament.length < 1 || parseFloat(row.abonament) <= 0)
                    {
                        props.mainView.showDialog("Ups!" , "Podaj wysokość abonamentu"  ,  "error"  ,null); 
                        return;
                    }

                     if(row.ilosc.length < 1 || parseFloat( row.ilosc) <= 0)
                    {
                        props.mainView.showDialog("Ups!" , "Podaj ilość "  ,  "error"  ,null); 
                        return;
                    }

                  
                }


                props.mainView.showProgress();
                

                fetch( Config.url + '/rest_v1_home,service_set', {
                    method: 'POST', 
                    body: JSON.stringify(row), 
                    headers: {
                        'Content-Type': 'application/json',                    
                        'X-Api-Key': props.userData.apiKey,
                        '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                        '_sec_key_': Config.genXKey() ,
                    }
                })
                .then(res => res.json() )
                .then(res => { 

                    
                            props.mainView.hideProgress();

                            if(res._sys_ == undefined)
                            {
                                props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                            }else
                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                            {
                                props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                            }else    
                            {
                                props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{
                                        if(props.onSuccess != undefined) props.onSuccess(res.result);         
                                } );                                                  
                                                            
                            }
                } )
                .catch(err => {          
                            props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                            props.mainView.hideProgress();
                });
                        

                return false;
            }

        const getSL = () => {
                
               
                props.mainView.showProgress();
                

                fetch( Config.url + '/rest_v1_home,sl_for_service', {
                    method: 'POST', 
                    body: JSON.stringify(row), 
                    headers: {
                        'Content-Type': 'application/json',                    
                        'X-Api-Key': props.userData.apiKey,
                        '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                        '_sec_key_': Config.genXKey() ,
                    }
                })
                .then(res => res.json() )
                .then(res => { 

                    
                            props.mainView.hideProgress();

                            if(res._sys_ == undefined)
                            {
                                props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                            }else
                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                            {
                                props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                            }else    
                            {
                                setSl(res.result);                                                            
                            }
                } )
                .catch(err => {          
                            props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                            props.mainView.hideProgress();
                });
                        

                return false;
            }

         const geServiceDet = () => {        

                    props.mainView.showProgress();
                

                    fetch( Config.url + '/rest_v1_home,service_det', {
                        method: 'POST', 
                        body: JSON.stringify( { id: props.id}), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    setRow(res.result);                                                 
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
                }


        const keyListener = (e)  => {


                         var code = e.keyCode ? e.keyCode : e.which;    

                            if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                            {
                                    e.target.blur();
                            } else 
                            if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                            {                                                      
                            } else
                            if( e.ctrlKey && code == 83 )   //zapisz                                               
                                {
                                       saveData();                          
                                       e.preventDefault();
                            } else                              
                            if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                            {
                                    props.onBack();                               
                            } else props.keyListener(e);

        }


        useEffect(() => {
            
                    if(props.id > 0 && row.id == -1)
                    {
                        geServiceDet();
                    }       
                    
                    if(sl == null) getSL();


                    if(Config.env == "dev") console.log("ServiceForm.js, listener on");
                    window.onkeydown = keyListener;

                    return () => {          
                        if(Config.env == "dev") console.log("ServiceForm.js, listener off");      
                        window.onkeydown = props.keyListener;
                    };

        });            



        if(row.nazwa_uslugi.length > 1)
        {
         document.title = row.nazwa_uslugi;
        }else 
        {
            document.title = "Szczegóły usługi";
        }


         return <div className="view_content">
                    <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>    

                    <h3 className="dash_header">{props.umowa.klient.nazwa} / Umowa {props.umowa.numer_umowy} / Usługa {row.nazwa_uslugi}</h3>

                    <form className="eForm bg_center">


                            <div className="form_tab">

                                    <div className="form_control">
                                            <div className="fieldName">Nazwa usługi / pozycji na fakturze*</div>
                                            <InputText   userData={props.userData} value={row.nazwa_uslugi} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwa_uslugi" placeholder={"Nazwa usługi"} className=' w300 ' req='1' firstUp="0" />
                                    </div>

                                    <div className="form_control">
                                            <div className="fieldName">Sposób definicji*</div>
                                            <InputCombo items={ [ {v:'n', title: 'Standard (ustalę cenę i ilość)'},  {v:'agr1', title: 'Agregacja ilości (ustalę cenę, ilość zostanie pobrana z innego systemu)'} ,  {v:'agr2', title: 'Agregacja ceny (wartość netto pobrana z innego systemu, ilosc=1)'}    ] }   value={row.typ} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="typ" placeholder={"Typ"} className='  ' req='1' firstUp="0" />
                                    </div>

                                {
                                    row.id > 0 &&
                                    <Fragment>

                                            <div className="form_control">
                                                <div className="fieldName">Fakturować*</div>
                                                <InputCombo items={ [ {v:'1', title: 'Tak'},  {v:'0', title: 'Nie'}      ] }   value={row.fakturowac} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="fakturowac" placeholder={""} className='  ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Usługa aktywna*</div>
                                                <InputCombo items={ [ {v:'1', title: 'Tak'},  {v:'0', title: 'Nie'}      ] }   value={row.usluga_aktywna} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="usluga_aktywna" placeholder={""} className='  ' req='1' firstUp="0" />
                                            </div>

                                    </Fragment>
                                }   

                                
                                <div className="form_control">
                                          <div className="fieldName">Data rozpoczęcia usługi*</div>
                                          <InputDate   value={row.data_rozpoczecia_uslugi} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_rozpoczecia_uslugi" placeholder={""} className='  ' req='0' firstUp="0" />
                                </div>   

                                <div className="form_control">
                                          <div className="fieldName">Data zakończenia usługi*</div>
                                          <InputDate   value={row.data_zakonczenia_uslugi} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_zakonczenia_uslugi" placeholder={""} className='  ' req='0' firstUp="0" />
                                </div>                                


                            </div>

                            {
                                (row.typ != 'agr1' && row.typ != 'agr2'  ) &&
                                 <div className="form_tab">
                                    {
                                        sl != null &&
                                        <Fragment>

                                                <div className="form_control">
                                                        <div className="fieldName">Usługa</div>
                                                        <InputCombo items={sl.usluga}  value={row.sl_uslugi_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sl_uslugi_id" placeholder={"Usługa"} className='  ' req='1' firstUp="0" />
                                                </div>                                            
                                                <div className="form_control">
                                                        <div className="fieldName">Cennik</div>
                                                        <InputCombo items={sl.cennik}  value={row.bill_cenniki_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="bill_cenniki_id" placeholder={"Cennik:"} className='  ' req='1' firstUp="0" />
                                                </div>
                                        </Fragment>
                                    }
                                </div>

                            }
                    

                           

                            {
                                row.typ == 'n' &&
                                <div className="form_tab">
                                             <div className="form_control">
                                                    <div className="fieldName">Aktywacja</div>
                                                    <InputDecimal   value={row.aktywacja} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="aktywacja" placeholder={"Aktywacja: "} className=' w100 ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                    <div className="fieldName">Kwota netto abonamentu</div>
                                                    <InputDecimal   value={row.abonament} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="abonament" placeholder={"Abonament: "} className=' w100 ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                    <div className="fieldName">Ilość</div>
                                                    <InputDecimal   value={row.ilosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="ilosc" placeholder={"Ilość: "} className=' w100 ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                    <div className="fieldName">Stawka VAT</div>
                                                    <InputInteger   value={row.stawka_vat} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="stawka_vat" placeholder={"Stawka VAT: "} className=' w100 ' req='1' firstUp="0" />
                                            </div>
                                </div> 
                            }

                            {
                                row.typ == 'agr1' &&
                                <div className="form_tab">
                                             <div className="form_control">
                                                    <div className="fieldName">Aktywacja</div>
                                                    <InputDecimal   value={row.aktywacja} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="aktywacja" placeholder={"Aktywacja: "} className=' w100 ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                    <div className="fieldName">Kwota j. netto abonamentu</div>
                                                    <InputDecimal   value={row.agr_cena_j_netto} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="agr_cena_j_netto" placeholder={"Cena j. netto: "} className=' w100 ' req='1' firstUp="0" />
                                            </div>
                                          

                                            <div className="form_control">
                                                    <div className="fieldName">Stawka VAT</div>
                                                    <InputInteger   value={row.stawka_vat} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="stawka_vat" placeholder={"Stawka VAT: "} className=' w100 ' req='1' firstUp="0" />
                                            </div>
                                </div> 
                            }

                            {
                                row.typ == 'agr2' &&
                                <div className="form_tab">
                                             <div className="form_control">
                                                    <div className="fieldName">Aktywacja</div>
                                                    <InputDecimal   value={row.aktywacja} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="aktywacja" placeholder={"Aktywacja: "} className=' w100 ' req='1' firstUp="0" />
                                            </div>
                                          
                                          

                                            <div className="form_control">
                                                    <div className="fieldName">Stawka VAT</div>
                                                    <InputInteger   value={row.stawka_vat} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="stawka_vat" placeholder={"Stawka VAT: "} className=' w100 ' req='1' firstUp="0" />
                                            </div>
                                </div> 
                            }




                             {
                                (row.typ == 'agr1' || row.typ == 'agr2'  ) &&
                                <div className="form_tab">

                                             <div className="form_control">
                                                    <div className="fieldName">Link do zewnętrznego systemu</div>
                                                    <InputText   value={row.agr_link} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="agr_link" placeholder={"Link: "} className=' w400 ' req='1' firstUp="0" />
                                            </div>       

                                            <div className="form_control">
                                                    <div className="fieldName">Metoda</div>
                                                    <InputCombo items={  [ {v:'CURL',title:'Curl'}, {v:'WSDL',title:'WSDL'}  ] }   value={row.agr_metoda} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="agr_metoda" placeholder={"Metoda: "} className='  ' req='0' firstUp="0" />
                                            </div>  

                                             <div className="form_control">
                                                    <div className="fieldName">Nazwa akcji:</div>
                                                    <InputText   value={row.agr_akcja} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="agr_akcja" placeholder={"Nazwa akcji: "} className='  ' req='1' firstUp="0" />
                                            </div>  

                                            
                                            <div className="form_control">
                                                    <div className="fieldName">Parametr 1:</div>
                                                    <InputCombo items={ [ {v:'none', title: 'Brak' }, {v:'{{ okres_biezacy }}', title: 'Okres bieżący (np. YYYY-MM)' }, {v:'{{ okres_wstecz }}', title: 'Okres poprzedni (np. YYYY-MM)' },  {v:'{{ okres_zakres }}', title: 'Okres bieżący (np. YYYY-MM-DD/YYYY-MM-DD)' },   {v:'{{ fak_kontrahenci_id }}', title: 'ID Klienta' } ,   {v:'{{ fak_sprzedawcy_id }}', title: 'ID Sprzedawcy' },   {v:'{{ fak_szczegoly_uslugi_id }}', title: 'ID Usługi' } ] }   value={row.agr_parametr1} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="agr_parametr1" placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div> 

                                            <div className="form_control">
                                                    <div className="fieldName">Parametr 2:</div>
                                                    <InputCombo items={ [ {v:'none', title: 'Brak' }, {v:'{{ okres_biezacy }}', title: 'Okres bieżący (np. YYYY-MM)' }, {v:'{{ okres_wstecz }}', title: 'Okres poprzedni (np. YYYY-MM)' },  {v:'{{ okres_zakres }}', title: 'Okres bieżący (np. YYYY-MM-DD/YYYY-MM-DD)' },   {v:'{{ fak_kontrahenci_id }}', title: 'ID Klienta' } ,   {v:'{{ fak_sprzedawcy_id }}', title: 'ID Sprzedawcy' },   {v:'{{ fak_szczegoly_uslugi_id }}', title: 'ID Usługi' } ] }   value={row.agr_parametr2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="agr_parametr2" placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div> 

                                            <div className="form_control">
                                                    <div className="fieldName">Parametr 3:</div>
                                                    <InputCombo items={ [ {v:'none', title: 'Brak' }, {v:'{{ okres_biezacy }}', title: 'Okres bieżący (np. YYYY-MM)' }, {v:'{{ okres_wstecz }}', title: 'Okres poprzedni (np. YYYY-MM)' },  {v:'{{ okres_zakres }}', title: 'Okres bieżący (np. YYYY-MM-DD/YYYY-MM-DD)' },   {v:'{{ fak_kontrahenci_id }}', title: 'ID Klienta' } ,   {v:'{{ fak_sprzedawcy_id }}', title: 'ID Sprzedawcy' },   {v:'{{ fak_szczegoly_uslugi_id }}', title: 'ID Usługi' } ] }   value={row.agr_parametr3} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="agr_parametr3" placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>   

                                            <div className="form_control">
                                                    <div className="fieldName">Parametr 4:</div>
                                                    <InputCombo items={ [ {v:'none', title: 'Brak' }, {v:'{{ okres_biezacy }}', title: 'Okres bieżący (np. YYYY-MM)' }, {v:'{{ okres_wstecz }}', title: 'Okres poprzedni (np. YYYY-MM)' },  {v:'{{ okres_zakres }}', title: 'Okres bieżący (np. YYYY-MM-DD/YYYY-MM-DD)' },   {v:'{{ fak_kontrahenci_id }}', title: 'ID Klienta' } ,   {v:'{{ fak_sprzedawcy_id }}', title: 'ID Sprzedawcy' },   {v:'{{ fak_szczegoly_uslugi_id }}', title: 'ID Usługi' } ] }   value={row.agr_parametr4} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="agr_parametr4" placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>                                
                                </div> 
                            }


                            {
                                (row.sl_uslugi_id == '2' || row.sl_uslugi_id == '3' || row.sl_uslugi_id == '4' || row.sl_uslugi_id == '5' || row.sl_uslugi_id == '6' || row.sl_uslugi_id == '7' || row.sl_uslugi_id == '11'   ) &&
                                <div className="form_tab">

                                            <div className="form_control">
                                                    <div className="fieldName">AccountCode:</div>
                                                    <InputText   value={row.accountcode} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="accountcode" placeholder={"AccountCode: "} className='  ' req='0' firstUp="0" />
                                            </div>  
                                        
                                            <div className="form_control">
                                                    <div className="fieldName">Numer PSTN:</div>
                                                    <InputText   value={row.numer_pstn} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="numer_pstn" placeholder={"Numer PSTN: "} className='  ' req='0' firstUp="0" />
                                            </div>  

                                            <div className="form_control">
                                                    <div className="fieldName">Numer Info:</div>
                                                    <InputText   value={row.numer_info} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="numer_info" placeholder={"Numer INFO: "} className='  ' req='0' firstUp="0" />
                                            </div>  

                                             <div className="form_control">
                                                    <div className="fieldName">Rabat na połączenia:</div>
                                                    <InputDecimal   value={row.rabat_na_polaczenia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rabat_na_polaczenia" placeholder={"Rabat na połączenia: "} className='  ' req='0' firstUp="0" />
                                            </div>  

                                            <div className="form_control">
                                                    <div className="fieldName">Rabat na abonament:</div>
                                                    <InputDecimal   value={row.rabat_na_abonament} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rabat_na_abonament" placeholder={"Rabat na abonament: "} className='  ' req='0' firstUp="0" />
                                            </div>  

                                            <div className="form_control">
                                                    <div className="fieldName">Ilość okresów dla rabatu:</div>
                                                    <InputDecimal   value={row.rabat_na_abonament_il_okresow} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rabat_na_abonament_il_okresow" placeholder={"Ilość okresów dla rabatów: "} className='  ' req='0' firstUp="0" />
                                            </div>  

                                             <div className="form_control">
                                                    <div className="fieldName">Koszty połączeń przychodzących:</div>
                                                    <InputDecimal   value={row.koszty_przekierowan} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="koszty_przekierowan" placeholder={"Koszty poł. przychodzących: "} className='  ' req='0' firstUp="0" />
                                            </div>  

                                             <div className="form_control">
                                                    <div className="fieldName">Koszty połączeń przychodzących (GSM):</div>
                                                    <InputDecimal   value={row.koszty_przekierowan_gsm} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="koszty_przekierowan_gsm" placeholder={"Koszty poł. przychodzących gms: "} className='  ' req='0' firstUp="0" />
                                            </div>  

                                            <div className="form_control">
                                                    <div className="fieldName">Udział 70x:</div>
                                                    <InputDecimal   value={row.udzial70x} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="udzial70x" placeholder={"Udział 70x: "} className='  ' req='0' firstUp="0" />
                                            </div>  
                                </div>
                            }



                            <div className="form_split"></div>

                                            <div className="form_btn">
                                                        <div className="btn" onClick={saveData}>zapisz zmiany [ctrl + s ]</div>
                                                        &nbsp;&nbsp;
                                                        <div className="btn" onClick={props.onBack}    > anuluj [back]</div>
                                            </div>


                    </form>

         </div>
}

export default ServiceForm;


